export function $formatToDigitalTime(seconds: number): string {
  if (seconds < 0) {
    seconds = 0;
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export function $formatToReadableFileTypes(fileTypes: string[]): string {
  const types = fileTypes.map((type) => type.split('/')[1]);

  // Format special cases
  types[
    types.indexOf('vnd.openxmlformats-officedocument.wordprocessingml.document')
  ] = 'docx';

  return types.join(', ');
}
